import MainLogo from "../../assets/MainLogo.webp";

const LoadingCircle = () => {
  return (
    <div className="loading">
      <img src={MainLogo} alt="Logo" style={{ height: 50 }} />
      <div className="loading-tree">
        <div className={`loading-dots dot`} />
        <div className={`loading-dots dot`} />
        <div className={`loading-dots dot`} />
      </div>
    </div>
  );
};

export default LoadingCircle;
